import { Directive, Input, ElementRef, HostListener } from '@angular/core';
import { environment } from '@env/environment';

// Asset local en vez de un servicio externo: via.placeholder.com esta dado
// de baja desde 2024, asi que como fallback por defecto solo generaba una
// peticion de red mas que tambien fallaba (a menudo con timeout, no 404).
const DEFAULT_FALLBACK_IMAGE = environment.assetsUrl + 'assets/images/img-fallback.svg';

@Directive({
  selector: 'img[appImgFallback]'
})
export class ImgFallbackDirective {

  @Input() appImgFallback: string;

  private fallbackApplied = false;

  constructor(private eRef: ElementRef) { }

  @HostListener('error')
  loadFallbackOnError() {
    if (this.fallbackApplied) {
      return;
    }
    this.fallbackApplied = true;
    const element: HTMLImageElement = <HTMLImageElement>this.eRef.nativeElement;
    element.src = this.appImgFallback || DEFAULT_FALLBACK_IMAGE;
  }

}
